import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const ExclamationIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.43068 2.78909C8.11918 1.56509 9.88048 1.56509 10.5681 2.78909L15.5901 11.7171C16.2651 12.9177 15.3984 14.3991 14.0223 14.3991H3.97738C2.60038 14.3991 1.73368 12.9177 2.40868 11.7171L7.43068 2.78909ZM9.89938 11.7C9.89938 11.9387 9.80455 12.1676 9.63577 12.3364C9.46699 12.5052 9.23807 12.6 8.99938 12.6C8.76068 12.6 8.53176 12.5052 8.36298 12.3364C8.1942 12.1676 8.09938 11.9387 8.09938 11.7C8.09938 11.4613 8.1942 11.2324 8.36298 11.0636C8.53176 10.8948 8.76068 10.8 8.99938 10.8C9.23807 10.8 9.46699 10.8948 9.63577 11.0636C9.80455 11.2324 9.89938 11.4613 9.89938 11.7V11.7ZM8.99938 4.49999C8.76068 4.49999 8.53176 4.59482 8.36298 4.7636C8.1942 4.93238 8.09938 5.1613 8.09938 5.39999V8.09999C8.09938 8.33869 8.1942 8.56761 8.36298 8.73639C8.53176 8.90517 8.76068 8.99999 8.99938 8.99999C9.23807 8.99999 9.46699 8.90517 9.63577 8.73639C9.80455 8.56761 9.89938 8.33869 9.89938 8.09999V5.39999C9.89938 5.1613 9.80455 4.93238 9.63577 4.7636C9.46699 4.59482 9.23807 4.49999 8.99938 4.49999Z"
      clipRule="evenodd"
      fillRule="evenodd"
      fill="#EF4A3C"
    />
  </svg>
);

export default ExclamationIcon;
